import $api from '../../utils/api.js'


const state = () => ({
    distributors: {
        total: 0,
        per_page: 2,
        from: 1,
        to: 0,
        current_page: 1
    },
    agents_distributor: {
        agents:[],
    },
    sorting: {
        num:10,
        search: '',
        offset: 4,
        placeholder:'Search Distributor'
    },
    formdata:{
        id:'',
        name:'',
        email:'',
        is_active:'true',
        password:'',
        confirmation:'',
    },
    errors:[],
})

const mutations = {
    ASSIGN_DATA(state, payload) {
        state.distributors = payload
    },
    ASSIGN_FORM(state, payload) {
        state.formdata = {
            id:payload.id,
            name:payload.name,
            email:payload.email,
            is_active:payload.is_active,
            password:'',
            confirmation:'',
        }
    },
    CLEAR_FORM(state) {
        state.formdata = {
            id:'',
            name:'',
            email:'',
            is_active:'true',
            password:'',
            confirmation:'',
        },
        state.errors = []
    },
    CLEAR_DISTRIBUTORS(state){
        state.distributors = {
            total: 0,
            per_page: 2,
            from: 1,
            to: 0,
            current_page: 1
        }
    },
    SET_ERRORS(state, payload) {
        state.errors = payload
    },

    // Distributor Agent

    ASSIGN_DATA_AGENTS_DISTRIBUTOR(state, payload) {
        state.agents_distributor = payload
    },
    CLEAR_DATA_AGENTS_DISTRIBUTOR(state) {
        state.agents_distributor = {
            agents:[],
        }
    }
}

const actions = {
    getDistributors({ commit, state }) {
        return new Promise((resolve) => {
            $api.get(`distributors?page=${state.distributors.current_page}&paginate=${state.sorting.num}&search=${state.sorting.search}`)
            .then((response) => {
                commit('ASSIGN_DATA', response.data)
                resolve(response.data)
            })
        })
    },
    createDistributors({ commit, state }) {
        return new Promise((resolve,reject) => {
            $api.post(`distributors`, state.formdata)
            .then((response) => {
                resolve(response.data)
            })
            .catch((error) => {
                if (error.response.status == 400) {
                    commit('SET_ERRORS', error.response.data.errors)
                }
                reject(error)
            })
        })
    },
    updateDistributors({ state, commit }, payload) {
        return new Promise((resolve,reject) => {
            $api.put(`distributors/${payload}`, state.formdata)
            .then((response) => {
                resolve(response.data)
            })
            .catch((error) => {
                if (error.response.status == 400) {
                    commit('SET_ERRORS', error.response.data.errors)
                }
                reject(error)
            })
        })
    },
    deleteDistributors({ dispatch }, payload) {
        return new Promise((resolve,reject) => {
            $api.delete(`distributors/${payload}`)
            .then(() => {
                dispatch('getDistributors').then(() => resolve())
            })
            .catch((error) => {
                reject(error)
            })
        })
    },
    changeStatusDistributors({ commit }, payload) {
        return new Promise((resolve,reject) => {
            $api.put(`status/distributors`, payload)
            .then((response) => {
                resolve(response.data)
            })
            .catch((error) => {
                if (error.response.status == 400) {
                    commit('SET_ERRORS', error.response.data.errors)
                }
                reject(error)
            })
        })
    },
    updateSlotsDistributors({ commit }, payload) {
        return new Promise((resolve,reject) => {
            $api.put(`slots/distributors/${payload.id}`, payload)
            .then((response) => {
                resolve(response.data)
            })
            .catch((error) => {
                if (error.response.status == 400) {
                    commit('SET_ERRORS', error.response.data.errors)
                }
                reject(error)
            })
        })
    },
    
}

export default {
    namespaced: true,
    state,
    actions,
    mutations
}